import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.31353 6.20808L17.2474 10.729C18.2509 11.3 18.2509 12.7 17.2474 13.271L9.31353 17.7919C8.29165 18.3748 7 17.6639 7 16.5199V7.48008C7 6.33607 8.29165 5.62525 9.31353 6.20808V6.20808Z",
		stroke: "#323232",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPlayArrow);
export default ForwardRef;
